export const BILLING_STORE_KEY = 'billing';
export const BILLING_SERVICE_KEY = 'billing';
export const BILLING_API_URL = '/api/v1/subscription/';
